import { MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { SelectOption } from 'src/types/common';
import { client } from '../../utils/axios-client';

type Props = {
    error?: string,
    value: string,
    onChange: (event: any) => void,
    label: string,
    type: string
}

const CustomSelect = ({ value, onChange, error = '', label, type }: Props) => {
    const [options, setOptions] = useState([] as SelectOption[])

    useEffect(() => {
        const loadOptions = async () => {
            const response = await client.get<SelectOption[]>(`/api/options/${type}`)
            setOptions(response.data);
        }

        loadOptions();
    }, [])

    return <Select
        size='small'
        fullWidth
        value={value}
        label={label}
        onChange={onChange}
        error={Boolean(error)}
        inputProps={{ placeholder: label }}
    >
        {options.map(item => <MenuItem value={item.value}>{item.name}</MenuItem>)}
    </Select>
}

export { CustomSelect }

export default CustomSelect